module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-42cf1ddbdaf9076fe7ddfd41e03a5139.png";